import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMeatComplaianceSummary,
  fetchMeatComplianceTrends,
  fetchMEATComplianceDistribution,
  fetchNonCompliantHCC,
  fetchMeatNonComplianceReport,
  fetchRenderingProvidersList,
  fetchPatientsList,
  fetchProgressNoteAnalysisDetails,
  listClinitianMeatCompliance,
  getRenderingProviderDetails,
  fetchHCCCategoriesCompliance,
  fetchHCCConditionCompliance,
  fetchHCCCategories,
  progressNotesUploadLatest,
  fetchProgressNotesUpload,
  submitAnalysisFeedback,
  fetchHccPeContradictionSummary,
  fetchNonCompliantHCCConditions,
  fetchNonCompliantHCCCategories,
  fetchContradictionProviderReport,
  fetchProgressNoteListing,
  fetchProgressNoteDetail,
  fetchHccPENoteAnalysisDetails,
  fetchBuddyCodingSummary,
  fetchMissedBuddyCodingOpportunity,
  fetchBuddyCodingProviderReport,
  fetchBuddyCodeAnalysisDetails,
  fetchDiagnosticStateSummary,
  fetchDiagnosticStateTrends,
  fetchDiagnosticStateCompliance,
  fetchDiagnosticStateClinicianComplianceReport,
  fetchDiagnosticStateProgressNoteDetail,
  fetchPendingSignatureSummary,
  fetchPendingSignatureCompliance,
  fetchOverallStats,
  fetchPendingSignatureProviderReport,
  fetchMEATNonComplianceTrends,
  fetchOverallComplianceTrends,
  fetchNonCompliantClinicianStats,
  fetchCompliantClinicianStats,
  fetchCompliantClinicStats,
  fetchNonCompliantClinicStats,
  fetchCompliantRegionStats,
  fetchNonCompliantRegionStats,
  fetchClinicProviderStats,
  fetchRegionProviderStats,
  fetchProgressNoteMEATDetails,
  fetchBuddyCodeSuggestionTrends,
  fetchClinics,
  fetchRegions,
} from "redux/actions/sensor/sensorAction";

const initialState = {
  complianceSummaryLoading: false,
  complianceSummary: null,
  complianceTrendsLoading: false,
  complianceTrends: null,
  complianceDistributionLoading: false,
  complianceDistribution: null,
  nonCompliantHCCsLoading: false,
  nonCompliantHCCs: null,
  meatNonComplianceListingPageLoading: false,
  meatNonComplianceListingPage: null,
  meatNonComplianceList: null,
  patientList: null,
  patientListLoading: false,
  renderingProvidersList: null,
  renderingProvidersListLoading: false,
  renderingProvider: null,
  renderingProviderLoading: false,
  clinitianMeatComplianceList: null,
  clinicianMeatComplianceTableListing: null,
  clinitianMeatComplianceListLoading: false,
  clinitianMeatComplianceListPage: null,
  analysisDetails: null,
  analysisDetailsLoading: false,
  hccCategoryComplianceList: null,
  hccCategoryComplianceListLoading: false,
  hccCategoriesComplianceListPage: null,
  hccConditionComplianceList: null,
  hccConditionCompliancelistloading: false,
  hccConditionComplianceListPage: null,
  hccCategoryList: null,
  hccCategoryListLoading: false,
  progressNotesUploadLatestLoading: true,
  progressNotesUploadsLatest: null,
  progressNotesUploads: null,
  progressNotesUploadPage: null,
  progressNotesUploadLoading: null,
  submitAnalysisFeedbackLoading: false,
  hccPeContradictionSummaryLoading: false,
  hccPeContradictionSummary: {},
  nonCompliantHCCConditionsLoading: false,
  nonCompliantHCCConditions: [],
  nonCompliantHCCCategoriesLoading: false,
  nonCompliantHCCCategories: [],
  contradictionProviderReportLoading: false,
  contradictionProviderReportPage: null,
  contradictionProviderReport: null,
  contradictionProviderReportListing: null,
  progressNoteListing: null,
  progressNoteListingLoading: false,
  progressNoteListingPage: null,
  progressNoteDetail: null,
  progressNoteDetailLoading: false,
  progressNoteHCCPEDetails: [],
  progressNoteHCCPEDetailsLoading: false,
  buddyCodingSummaryLoading: false,
  buddyCodingSummary: {},
  missedBuddyCodingOpportunityLoading: false,
  missedBuddyCodingOpportunities: [],
  buddyCodingProviderReportLoading: false,
  buddyCodingProviderReportPage: null,
  buddyCodingProviderReport: null,
  buddyCodingProviderReportListing: null,
  progressNotesBuddyCodingAnalysisDetails: [],
  progressNotesBuddyCodingAnalysisDetailsLoading: false,
  diagnosticStateSummary: {},
  diagnosticStateSummaryLoading: false,
  diagnosticStateAnalysisTrends: null,
  diagnosticStateAnalysisTrendsLoading: false,
  diagnosticStateComplianceLoading: false,
  diagnosticStateCompliance: [],
  diagnosticStateProviderReportLoading: false,
  diagnosticStateProviderReportPage: null,
  diagnosticStateProviderReport: null,
  diagnosticStateProviderReportListing: null,
  progressNoteDiagnosticState: [],
  progressNoteDiagnosticStateLoading: false,
  pendingSignatureSummaryLoading: false,
  pendingSignatureSummary: {},
  pendingSignatureCompliance: [],
  pendingSignatureComplianceLoading: false,
  overallStatsLoading: false,
  overallStats: {},
  pendingSignatureProviderReportLoading: false,
  pendingSignatureProviderReportPage: null,
  pendingSignatureProviderReport: null,
  meatNonComplianceTrends: null,
  meatNonComplianceTrendsLoading: false,
  overallComplianceTrends: [],
  overallComplianceTrendsLoading: false,
  overallClinicanStats: null,
  overallClinicanStatsLoading: false,
  overallClinicanStatsPage: null,
  topNonCompliantCliniciansLoading: false,
  topNonCompliantClinicians: null,
  topCompliantClinicsLoading: false,
  topNonCompliantClinics: null,
  topNonCompliantClinicsLoading: false,
  topCompliantRegionStats: [],
  topCompliantRegionStatsLoading: false,
  clinicProviderStats: null,
  clinicProviderStatsLoading: false,
  clinicProviderStatsPage: null,
  regionProviderStatsLoading: false,
  regionProviderStatsPage: null,
  regionProviderStats: null,
  topNonCompliantClinicians: null,
  topNonCompliantCliniciansLoading: false,
  topCompliantClinicians: null,
  topCompliantCliniciansLoading: false,
  topCompliantClinics: [],
  topCompliantClinicsLoading: null,
  topNonCompliantClinics: null,
  topNonCompliantClinicsLoading: null,
  topNonCompliantRegionStats: null,
  topNonCompliantRegionStatsLoading: false,
  clinicProviderStatsLoading: false,
  clinicProivderStats: null,
  clinicProviderStatsPage: null,
  regionProviderStatsLoading: false,
  regionProviderStats: null,
  regionProviderStatsPage: null,
  meatAnalysisDetails: null,
  meatAnalysisDetailsLoading: false,
  feedbackStatus: {},
  buddyCodingSuggestionTrends: [],
  buddyCodingSuggestionTrendsLoading: false,
  clinicsList: null,
  clinicsListLoading: false,
  regionList: null,
  regionListLoading: false,
};

const sensorDataSlice = createSlice({
  name: "sensorData",
  initialState,
  reducers: {
    setSensorState: (state, { payload }) => {
      // payload is an object where key is the state and data is the value
      // set value if state exists in initialState
      Object.keys(payload).forEach((key) => {
        if (key in initialState) {
          state[key] = payload[key];
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeatComplaianceSummary.pending, (state) => {
        state.complianceSummaryLoading = true;
        state.complianceSummary = null;
      })
      .addCase(fetchMeatComplaianceSummary.fulfilled, (state, { payload }) => {
        state.complianceSummaryLoading = false;
        state.complianceSummary = payload;
      })
      .addCase(fetchMeatComplaianceSummary.rejected, (state) => {
        state.complianceSummaryLoading = false;
        state.complianceSummary = null;
      })
      .addCase(fetchMeatComplianceTrends.pending, (state) => {
        state.complianceTrendsLoading = true;
        state.complianceTrends = null;
      })
      .addCase(fetchMeatComplianceTrends.fulfilled, (state, { payload }) => {
        state.complianceTrendsLoading = false;
        state.complianceTrends = payload;
      })
      .addCase(fetchMeatComplianceTrends.rejected, (state) => {
        state.complianceTrendsLoading = false;
        state.complianceTrends = null;
      })
      .addCase(fetchMEATComplianceDistribution.pending, (state) => {
        state.complianceDistributionLoading = true;
        state.complianceDistribution = null;
      })
      .addCase(
        fetchMEATComplianceDistribution.fulfilled,
        (state, { payload }) => {
          state.complianceDistributionLoading = false;
          state.complianceDistribution = payload;
        }
      )
      .addCase(fetchMEATComplianceDistribution.rejected, (state) => {
        state.complianceDistributionLoading = false;
        state.complianceDistribution = null;
      })
      .addCase(fetchNonCompliantHCC.pending, (state) => {
        state.nonCompliantHCCsLoading = true;
        state.nonCompliantHCCs = null;
      })
      .addCase(fetchNonCompliantHCC.fulfilled, (state, { payload }) => {
        state.nonCompliantHCCsLoading = false;
        state.nonCompliantHCCs = payload;
      })
      .addCase(fetchNonCompliantHCC.rejected, (state) => {
        state.nonCompliantHCCsLoading = false;
        state.nonCompliantHCCs = null;
      })
      .addCase(fetchMeatNonComplianceReport.pending, (state) => {
        state.meatNonComplianceListingPageLoading = true;
      })
      .addCase(fetchMeatNonComplianceReport.fulfilled, (state, { payload }) => {
        state.meatNonComplianceListingPageLoading = false;
        state.meatNonComplianceListingPage = payload.page;
        state.meatNonComplianceList = payload.results;
      })
      .addCase(fetchMeatNonComplianceReport.rejected, (state) => {
        state.meatNonComplianceListingPageLoading = false;
        state.meatNonComplianceListingPage = null;
      })
      .addCase(fetchRenderingProvidersList.pending, (state) => {
        state.renderingProvidersListLoading = true;
        state.renderingProvidersList = null;
      })
      .addCase(fetchRenderingProvidersList.fulfilled, (state, { payload }) => {
        state.renderingProvidersListLoading = false;
        state.renderingProvidersList = payload.results;
      })
      .addCase(fetchRenderingProvidersList.rejected, (state) => {
        state.renderingProvidersListLoading = false;
        state.renderingProvidersList = null;
      })
      .addCase(getRenderingProviderDetails.pending, (state) => {
        state.renderingProviderLoading = true;
        state.renderingProvider = null;
      })
      .addCase(getRenderingProviderDetails.fulfilled, (state, { payload }) => {
        state.renderingProviderLoading = false;
        state.renderingProvider = payload;
      })
      .addCase(getRenderingProviderDetails.rejected, (state) => {
        state.renderingProviderLoading = false;
        state.renderingProvider = null;
      })
      .addCase(fetchPatientsList.pending, (state) => {
        state.patientListLoading = true;
        state.patientList = null;
      })
      .addCase(fetchPatientsList.fulfilled, (state, { payload }) => {
        state.patientListLoading = false;
        state.patientList = payload.results;
      })
      .addCase(fetchPatientsList.rejected, (state) => {
        state.patientListLoading = false;
        state.patientList = null;
      })
      .addCase(listClinitianMeatCompliance.pending, (state) => {
        state.clinitianMeatComplianceListLoading = true;
      })
      .addCase(listClinitianMeatCompliance.fulfilled, (state, { payload }) => {
        state.clinitianMeatComplianceListLoading = false;
        state.clinitianMeatComplianceListPage = payload.page;
        state.clinitianMeatComplianceList =
          payload.page.number > 1
            ? [...(state.clinitianMeatComplianceList ?? []), ...payload.results]
            : [...payload.results];
        state.clinicianMeatComplianceTableListing = payload.results;
      })
      .addCase(listClinitianMeatCompliance.rejected, (state) => {
        state.clinitianMeatComplianceListLoading = false;
        state.clinitianMeatComplianceList = null;
        state.clinitianMeatComplianceListPage = null;
      })
      .addCase(fetchProgressNoteAnalysisDetails.pending, (state) => {
        state.analysisDetailsLoading = true;
      })
      .addCase(
        fetchProgressNoteAnalysisDetails.fulfilled,
        (state, { payload }) => {
          state.analysisDetailsLoading = false;
          state.analysisDetails = payload;
        }
      )
      .addCase(fetchProgressNoteAnalysisDetails.rejected, (state) => {
        (state.analysisDetailsLoading = false), (state.analysisDetails = null);
      })
      .addCase(fetchHCCCategoriesCompliance.pending, (state) => {
        state.hccCategoryComplianceListLoading = true;
      })
      .addCase(fetchHCCCategoriesCompliance.fulfilled, (state, { payload }) => {
        (state.hccCategoryComplianceListLoading = false),
          (state.hccCategoriesComplianceListPage = payload.page),
          (state.hccCategoryComplianceList = payload.results);
      })
      .addCase(fetchHCCCategoriesCompliance.rejected, (state) => {
        (state.hccCategoryComplianceListLoading = false),
          (state.hccCategoriesComplianceListPage = null),
          (state.hccCategoryComplianceList = null);
      })
      .addCase(fetchHCCConditionCompliance.pending, (state) => {
        state.hccConditionCompliancelistloading = true;
      })
      .addCase(fetchHCCConditionCompliance.fulfilled, (state, { payload }) => {
        (state.hccConditionCompliancelistloading = false),
          (state.hccConditionComplianceListPage = payload.page),
          (state.hccConditionComplianceList = payload.results);
      })
      .addCase(fetchHCCConditionCompliance.rejected, (state) => {
        (state.hccConditionCompliancelistloading = false),
          (state.hccConditionComplianceListPage = null),
          (state.hccConditionComplianceList = null);
      })
      .addCase(fetchHCCCategories.pending, (state) => {
        state.hccCategoryListLoading = true;
      })
      .addCase(fetchHCCCategories.fulfilled, (state, { payload }) => {
        (state.hccCategoryListLoading = false),
          (state.hccCategoryList = payload.results);
      })
      .addCase(fetchHCCCategories.rejected, (state) => {
        (state.hccCategoryListLoading = false), (state.hccCategoryList = null);
      })
      .addCase(progressNotesUploadLatest.pending, (state) => {
        state.progressNotesUploadLatestLoading = true;
      })
      .addCase(progressNotesUploadLatest.fulfilled, (state, { payload }) => {
        (state.progressNotesUploadLatestLoading = false),
          (state.progressNotesUploadsLatest = payload);
      })
      .addCase(progressNotesUploadLatest.rejected, (state) => {
        (state.progressNotesUploadLatestLoading = false),
          (state.progressNotesUploadsLatest = null);
      })
      .addCase(fetchProgressNotesUpload.pending, (state) => {
        state.progressNotesUploadLoading = true;
      })
      .addCase(fetchProgressNotesUpload.fulfilled, (state, { payload }) => {
        (state.progressNotesUploadLoading = false),
          (state.progressNotesUploadPage = payload.page),
          (state.progressNotesUploads = payload.results);
      })
      .addCase(fetchProgressNotesUpload.rejected, (state) => {
        (state.progressNotesUploadLatest = false),
          (state.progressNotesUploadPage = null),
          (state.progressNotesUploads = null);
      })
      .addCase(submitAnalysisFeedback.pending, (state) => {
        state.submitAnalysisFeedbackLoading = true;
      })
      .addCase(submitAnalysisFeedback.fulfilled, (state, action) => {
        state.submitAnalysisFeedbackLoading = false;
        state.feedbackStatus[action.payload.condition] = true;

        if (state.analysisDetails && state.analysisDetails.condition_analysis) {
          const conditionToUpdate =
            state.analysisDetails.condition_analysis.find(
              (cond) => cond.matched_icd_10 === action.payload.condition
            );
          if (conditionToUpdate) {
            conditionToUpdate.is_feedback_given = true;
          }
        }
      })
      .addCase(submitAnalysisFeedback.rejected, (state, action) => {
        state.submitAnalysisFeedbackLoading = false;
      })
      .addCase(fetchHccPeContradictionSummary.pending, (state) => {
        state.hccPeContradictionSummaryLoading = true;
      })
      .addCase(
        fetchHccPeContradictionSummary.fulfilled,
        (state, { payload }) => {
          state.hccPeContradictionSummaryLoading = false;
          state.hccPeContradictionSummary = payload;
        }
      )
      .addCase(fetchHccPeContradictionSummary.rejected, (state) => {
        state.hccPeContradictionSummaryLoading = false;
        state.hccPeContradictionSummary = null;
      })
      .addCase(fetchNonCompliantHCCConditions.pending, (state) => {
        state.nonCompliantHCCConditionsLoading = true;
      })
      .addCase(
        fetchNonCompliantHCCConditions.fulfilled,
        (state, { payload }) => {
          state.nonCompliantHCCConditionsLoading = false;
          state.nonCompliantHCCConditions = payload;
        }
      )
      .addCase(fetchNonCompliantHCCConditions.rejected, (state) => {
        state.nonCompliantHCCConditionsLoading = false;
        state.nonCompliantHCCConditions = [];
      })
      .addCase(fetchNonCompliantHCCCategories.pending, (state) => {
        state.nonCompliantHCCCategoriesLoading = true;
      })
      .addCase(
        fetchNonCompliantHCCCategories.fulfilled,
        (state, { payload }) => {
          state.nonCompliantHCCCategoriesLoading = false;
          state.nonCompliantHCCCategories = payload;
        }
      )
      .addCase(fetchNonCompliantHCCCategories.rejected, (state) => {
        state.nonCompliantHCCCategoriesLoading = false;
        state.nonCompliantHCCCategories = [];
      })
      .addCase(fetchContradictionProviderReport.pending, (state) => {
        state.contradictionProviderReportLoading = true;
      })
      .addCase(
        fetchContradictionProviderReport.fulfilled,
        (state, { payload }) => {
          state.contradictionProviderReportLoading = false;
          state.contradictionProviderReportPage = payload.page;
          state.contradictionProviderReport =
            payload.page.number > 1
              ? [
                  ...(state.contradictionProviderReport ?? []),
                  ...payload.results,
                ]
              : [...payload.results];
          state.contradictionProviderReportListing = payload.results;
        }
      )
      .addCase(fetchContradictionProviderReport.rejected, (state) => {
        state.contradictionProviderReportLoading = false;
        state.contradictionProviderReport = null;
        state.contradictionProviderReportPage = null;
      })
      .addCase(fetchProgressNoteListing.pending, (state) => {
        state.progressNoteListingLoading = true;
      })
      .addCase(fetchProgressNoteListing.fulfilled, (state, { payload }) => {
        state.progressNoteListingLoading = false;
        state.progressNoteListing = payload.results;
        state.progressNoteListingPage = payload.page;
      })
      .addCase(fetchProgressNoteListing.rejected, (state) => {
        state.progressNoteListingLoading = false;
        state.progressNoteListing = null;
        state.progressNoteListingPage = null;
      })
      .addCase(fetchProgressNoteDetail.pending, (state) => {
        state.progressNoteDetailLoading = true;
      })
      .addCase(fetchProgressNoteDetail.fulfilled, (state, { payload }) => {
        state.progressNoteDetailLoading = false;
        state.progressNoteDetail = payload;
      })
      .addCase(fetchProgressNoteDetail.rejected, (state) => {
        state.progressNoteDetailLoading = false;
        state.progressNoteDetail = null;
      })
      .addCase(fetchHccPENoteAnalysisDetails.pending, (state) => {
        state.progressNoteHCCPEDetailsLoading = true;
      })
      .addCase(
        fetchHccPENoteAnalysisDetails.fulfilled,
        (state, { payload }) => {
          state.progressNoteHCCPEDetailsLoading = false;
          state.progressNoteHCCPEDetails = payload.condition_analyses;
        }
      )
      .addCase(fetchHccPENoteAnalysisDetails.rejected, (state) => {
        state.progressNoteHCCPEDetailsLoading = false;
        state.progressNoteHCCPEDetails = null;
      })
      .addCase(fetchBuddyCodingSummary.pending, (state) => {
        state.buddyCodingSummaryLoading = true;
      })
      .addCase(fetchBuddyCodingSummary.fulfilled, (state, { payload }) => {
        state.buddyCodingSummaryLoading = false;
        state.buddyCodingSummary = payload;
      })
      .addCase(fetchBuddyCodingSummary.rejected, (state) => {
        state.buddyCodingSummaryLoading = false;
        state.buddyCodingSummary = null;
      })
      .addCase(fetchMissedBuddyCodingOpportunity.pending, (state) => {
        state.missedBuddyCodingOpportunityLoading = true;
      })
      .addCase(
        fetchMissedBuddyCodingOpportunity.fulfilled,
        (state, { payload }) => {
          state.missedBuddyCodingOpportunityLoading = false;
          state.missedBuddyCodingOpportunities = payload;
        }
      )
      .addCase(fetchMissedBuddyCodingOpportunity.rejected, (state) => {
        state.missedBuddyCodingOpportunityLoading = false;
        state.missedBuddyCodingOpportunities = null;
      })
      .addCase(fetchBuddyCodingProviderReport.pending, (state) => {
        state.buddyCodingProviderReportLoading = true;
      })
      .addCase(
        fetchBuddyCodingProviderReport.fulfilled,
        (state, { payload }) => {
          state.buddyCodingProviderReportLoading = false;
          state.buddyCodingProviderReportPage = payload.page;
          state.buddyCodingProviderReport =
            payload.page.number > 1
              ? [...(state.buddyCodingProviderReport ?? []), ...payload.results]
              : [...payload.results];
          state.buddyCodingProviderReportListing = payload.results;
        }
      )
      .addCase(fetchBuddyCodingProviderReport.rejected, (state) => {
        state.buddyCodingProviderReportLoading = false;
        state.buddyCodingProviderReport = null;
        state.buddyCodingProviderReportPage = null;
      })
      .addCase(fetchBuddyCodeAnalysisDetails.pending, (state) => {
        state.progressNotesBuddyCodingAnalysisDetailsLoading = true;
      })
      .addCase(
        fetchBuddyCodeAnalysisDetails.fulfilled,
        (state, { payload }) => {
          state.progressNotesBuddyCodingAnalysisDetailsLoading = false;
          state.progressNotesBuddyCodingAnalysisDetails = payload;
        }
      )
      .addCase(fetchBuddyCodeAnalysisDetails.rejected, (state) => {
        state.progressNotesBuddyCodingAnalysisDetailsLoading = false;
        state.progressNotesBuddyCodingAnalysisDetails = [];
      })
      .addCase(fetchDiagnosticStateSummary.pending, (state) => {
        state.diagnosticStateSummaryLoading = true;
      })
      .addCase(fetchDiagnosticStateSummary.fulfilled, (state, { payload }) => {
        state.diagnosticStateSummaryLoading = false;
        state.diagnosticStateSummary = payload;
      })
      .addCase(fetchDiagnosticStateSummary.rejected, (state) => {
        (state.diagnosticStateSummaryLoading = false),
          (state.diagnosticStateSummary = {});
      })
      .addCase(fetchDiagnosticStateTrends.pending, (state) => {
        state.diagnosticStateAnalysisTrendsLoading = true;
      })
      .addCase(fetchDiagnosticStateTrends.fulfilled, (state, { payload }) => {
        state.diagnosticStateAnalysisTrendsLoading = false;
        state.diagnosticStateAnalysisTrends = payload;
      })
      .addCase(fetchDiagnosticStateTrends.rejected, (state) => {
        state.diagnosticStateAnalysisTrendsLoading = false;
        state.diagnosticStateAnalysisTrends = null;
      })
      .addCase(fetchDiagnosticStateCompliance.pending, (state) => {
        state.diagnosticStateComplianceLoading = true;
      })
      .addCase(
        fetchDiagnosticStateCompliance.fulfilled,
        (state, { payload }) => {
          state.diagnosticStateComplianceLoading = false;
          state.diagnosticStateCompliance = payload;
        }
      )
      .addCase(
        fetchDiagnosticStateCompliance.rejected,
        (state, { payload }) => {
          state.diagnosticStateComplianceLoading = false;
          state.diagnosticStateCompliance = null;
        }
      )
      .addCase(
        fetchDiagnosticStateClinicianComplianceReport.pending,
        (state) => {
          state.diagnosticStateProviderReportLoading = true;
        }
      )
      .addCase(
        fetchDiagnosticStateClinicianComplianceReport.fulfilled,
        (state, { payload }) => {
          state.diagnosticStateProviderReportLoading = false;
          state.diagnosticStateProviderReportPage = payload.page;
          state.diagnosticStateProviderReport =
            payload.page.number > 1
              ? [
                  ...(state.diagnosticStateProviderReport ?? []),
                  ...payload.results,
                ]
              : [...payload.results];
          state.diagnosticStateProviderReportListing = payload.results;
        }
      )
      .addCase(
        fetchDiagnosticStateClinicianComplianceReport.rejected,
        (state) => {
          state.diagnosticStateProviderReportLoading = false;
          state.diagnosticStateProviderReport = null;
          state.diagnosticStateProviderReportPage = null;
        }
      )
      .addCase(fetchDiagnosticStateProgressNoteDetail.pending, (state) => {
        state.progressNoteDiagnosticStateLoading = true;
      })
      .addCase(
        fetchDiagnosticStateProgressNoteDetail.fulfilled,
        (state, { payload }) => {
          state.progressNoteDiagnosticStateLoading = false;
          state.progressNoteDiagnosticState =
            payload.condition_diagnostic_states;
        }
      )
      .addCase(fetchDiagnosticStateProgressNoteDetail.rejected, (state) => {
        state.progressNoteDiagnosticStateLoading = false;
        state.progressNoteDiagnosticState = null;
      })
      .addCase(fetchPendingSignatureSummary.pending, (state) => {
        state.pendingSignatureSummaryLoading = true;
      })
      .addCase(fetchPendingSignatureSummary.fulfilled, (state, { payload }) => {
        state.pendingSignatureSummaryLoading = false;
        state.pendingSignatureSummary = payload;
      })
      .addCase(fetchPendingSignatureSummary.rejected, (state) => {
        state.pendingSignatureSummaryLoading = false;
        state.pendingSignatureSummary = null;
      })
      .addCase(fetchPendingSignatureCompliance.pending, (state) => {
        state.pendingSignatureComplianceLoading = true;
      })
      .addCase(
        fetchPendingSignatureCompliance.fulfilled,
        (state, { payload }) => {
          state.pendingSignatureComplianceLoading = false;
          state.pendingSignatureCompliance = payload;
        }
      )
      .addCase(fetchPendingSignatureCompliance.rejected, (state) => {
        state.pendingSignatureComplianceLoading = false;
        state.pendingSignatureCompliance = null;
      })
      .addCase(fetchOverallStats.pending, (state) => {
        state.overallStatsLoading = true;
      })
      .addCase(fetchOverallStats.fulfilled, (state, { payload }) => {
        state.overallStatsLoading = false;
        state.overallStats = payload;
      })
      .addCase(fetchOverallStats.rejected, (state) => {
        state.overallStatsLoading = false;
        state.overallStats = null;
      })
      .addCase(fetchPendingSignatureProviderReport.pending, (state) => {
        state.pendingSignatureProviderReportLoading = true;
      })
      .addCase(
        fetchPendingSignatureProviderReport.fulfilled,
        (state, { payload }) => {
          state.pendingSignatureProviderReportLoading = false;
          state.pendingSignatureProviderReportPage = payload.page;
          state.pendingSignatureProviderReport = payload.results;
        }
      )
      .addCase(fetchPendingSignatureProviderReport.rejected, (state) => {
        state.pendingSignatureProviderReportLoading = false;
        state.pendingSignatureProviderReport = null;
        state.pendingSignatureProviderReportPage = null;
      })
      .addCase(fetchMEATNonComplianceTrends.pending, (state) => {
        state.meatNonComplianceTrendsLoading = true;
      })
      .addCase(fetchMEATNonComplianceTrends.fulfilled, (state, { payload }) => {
        state.meatNonComplianceTrendsLoading = false;
        state.meatNonComplianceTrends = payload;
      })
      .addCase(fetchMEATNonComplianceTrends.rejected, (state) => {
        state.meatNonComplianceTrendsLoading = false;
        state.meatNonComplianceTrends = null;
      })
      .addCase(fetchOverallComplianceTrends.pending, (state) => {
        state.overallComplianceTrendsLoading = true;
      })
      .addCase(fetchOverallComplianceTrends.fulfilled, (state, { payload }) => {
        state.overallComplianceTrendsLoading = false;
        state.overallComplianceTrends = payload;
      })
      .addCase(fetchOverallComplianceTrends.rejected, (state) => {
        state.overallComplianceTrendsLoading = false;
      })
      .addCase(fetchNonCompliantClinicianStats.pending, (state) => {
        state.topNonCompliantCliniciansLoading = true;
      })
      .addCase(
        fetchNonCompliantClinicianStats.fulfilled,
        (state, { payload }) => {
          state.topNonCompliantCliniciansLoading = false;
          state.topNonCompliantClinicians = payload.results;
        }
      )
      .addCase(fetchNonCompliantClinicianStats.rejected, (state) => {
        state.topNonCompliantCliniciansLoading = false;
        state.topNonCompliantClinicians = null;
      })
      .addCase(fetchCompliantClinicianStats.pending, (state) => {
        state.topCompliantCliniciansLoading = true;
      })
      .addCase(fetchCompliantClinicianStats.fulfilled, (state, { payload }) => {
        state.topCompliantCliniciansLoading = false;
        state.topCompliantClinicians = payload.results;
        state.topCompliantCliniciansPage = payload.page;
      })
      .addCase(fetchCompliantClinicianStats.rejected, (state, { payload }) => {
        state.topCompliantCliniciansLoading = false;
        state.topCompliantClinicians = null;
        state.topCompliantCliniciansPage = null;
      })
      .addCase(fetchCompliantClinicStats.pending, (state) => {
        state.topCompliantClinicsLoading = true;
      })
      .addCase(fetchCompliantClinicStats.fulfilled, (state, { payload }) => {
        state.topCompliantClinicsLoading = false;
        state.topCompliantClinics = payload.results;
        state.topCompliantClinicsPage = payload.page;
      })
      .addCase(fetchCompliantClinicStats.rejected, (state) => {
        state.topCompliantClinicsLoading = false;
        state.topCompliantClinics = null;
        state.topCompliantClinicsPage = null;
      })
      .addCase(fetchNonCompliantClinicStats.pending, (state) => {
        state.topNonCompliantClinicsLoading = true;
      })
      .addCase(fetchNonCompliantClinicStats.fulfilled, (state, { payload }) => {
        state.topNonCompliantClinicsLoading = false;
        state.topNonCompliantClinics = payload.results;
      })
      .addCase(fetchNonCompliantClinicStats.rejected, (state) => {
        state.topNonCompliantClinicsLoading = false;
        state.topNonCompliantClinics = null;
      })
      .addCase(fetchCompliantRegionStats.pending, (state) => {
        state.topCompliantRegionStatsLoading = true;
      })
      .addCase(fetchCompliantRegionStats.fulfilled, (state, { payload }) => {
        state.topCompliantRegionStatsLoading = false;
        state.topCompliantRegionStats = payload.results;
        state.topCompliantRegionStatsPage = payload.page;
      })
      .addCase(fetchCompliantRegionStats.rejected, (state) => {
        state.topCompliantRegionStatsLoading = false;
        state.topCompliantRegionStats = null;
        state.topCompliantRegionStatsPage = null;
      })
      .addCase(fetchNonCompliantRegionStats.pending, (state) => {
        state.topNonCompliantRegionStatsLoading = true;
      })
      .addCase(fetchNonCompliantRegionStats.fulfilled, (state, { payload }) => {
        state.topNonCompliantRegionStatsLoading = false;
        state.topNonCompliantRegionStats = payload.results;
      })
      .addCase(fetchNonCompliantRegionStats.rejected, (state) => {
        state.topNonCompliantRegionStatsLoading = false;
        state.topNonCompliantRegionStats = null;
      })
      .addCase(fetchClinicProviderStats.pending, (state) => {
        state.clinicProviderStatsLoading = true;
      })
      .addCase(fetchClinicProviderStats.fulfilled, (state, { payload }) => {
        state.clinicProviderStatsLoading = false;
        state.clinicProviderStats = payload.results;
        state.clinicProviderStatsPage = payload.page;
      })
      .addCase(fetchClinicProviderStats.rejected, (state, { payload }) => {
        state.clinicProviderStatsLoading = false;
        state.clinicProviderStats = null;
        state.clinicProviderStatsPage = null;
      })
      .addCase(fetchRegionProviderStats.pending, (state) => {
        state.regionProviderStatsLoading = true;
      })
      .addCase(fetchRegionProviderStats.fulfilled, (state, { payload }) => {
        state.regionProviderStatsLoading = false;
        state.regionProviderStats = payload.results;
        state.regionProviderStatsPage = payload.page;
      })
      .addCase(fetchRegionProviderStats.rejected, (state, { payload }) => {
        state.regionProviderStatsLoading = false;
        state.regionProviderStats = null;
        state.regionProviderStatsPage = null;
      })
      .addCase(fetchProgressNoteMEATDetails.pending, (state) => {
        state.meatAnalysisDetailsLoading = true;
      })
      .addCase(fetchProgressNoteMEATDetails.fulfilled, (state, { payload }) => {
        state.meatAnalysisDetailsLoading = false;
        state.meatAnalysisDetails = payload;
      })
      .addCase(fetchProgressNoteMEATDetails.rejected, (state) => {
        state.meatAnalysisDetailsLoading = false;
        state.meatAnalysisDetails = null;
      })
      .addCase(fetchBuddyCodeSuggestionTrends.pending, (state) => {
        state.buddyCodingSuggestionTrendsLoading = true;
      })
      .addCase(
        fetchBuddyCodeSuggestionTrends.fulfilled,
        (state, { payload }) => {
          state.buddyCodingSuggestionTrendsLoading = false;
          state.buddyCodingSuggestionTrends = payload;
        }
      )
      .addCase(fetchBuddyCodeSuggestionTrends.rejected, (state) => {
        state.buddyCodingSuggestionTrendsLoading = false;
        state.buddyCodingSuggestionTrends = [];
      })
      .addCase(fetchClinics.pending, (state) => {
        state.clinicsListLoading = true;
      })
      .addCase(fetchClinics.fulfilled, (state, { payload }) => {
        state.clinicsListLoading = false;
        state.clinicsList = payload.results;
      })
      .addCase(fetchClinics.rejected, (state) => {
        state.clinicsListLoading = false;
        state.clinicsList = null;
      })
      .addCase(fetchRegions.pending, (state) => {
        state.regionListLoading = true;
      })
      .addCase(fetchRegions.fulfilled, (state, { payload }) => {
        state.regionListLoading = false;
        state.regionList = payload.results;
      })
      .addCase(fetchRegions.rejected, (state) => {
        state.regionListLoading = false;
        state.regionList = null;
      });
  },
});

export const { setSensorState } = sensorDataSlice.actions;

export default sensorDataSlice.reducer;
